/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Form, Space } from 'antd';
import { useParams } from 'react-router';
import { useHeroApiService } from '@core/hooks';
import { Inquiry, LocalLocation } from '@core/models';
import LoadableContainer from '@components/LoadableContainer';
import { CheckOutlined, LoadingOutlined, MehOutlined } from '@ant-design/icons';
import { useBreakpoint } from '@core/hooks/useBreakpoint';
import { useAppDispatch } from '@core/configureStore';
import { openInquiryEmail } from '@core/features/inquiry/thunks';
import Icon from '@ant-design/icons/lib/components/Icon';
import { getGoogleUrl } from '@constants/auth';

type Props = {};

const RenderFinishedContent = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      <CheckOutlined style={{ fontSize: 50, color: 'green' }} />
      <div style={{ marginTop: 30, textAlign: 'center', width: '70%' }}>
        <h1>Submitted</h1>
        <p>Thank you for spending your time. We will reach out to you soon</p>
      </div>
    </div>
  );
};

const InquiryCallbackScreen = (props: Props) => {
  const breakpoint = useBreakpoint();
  const dispatch = useAppDispatch();
  const heroApiService = useHeroApiService();
  const [location, setLocation] = useState<LocalLocation | null>(null);
  const [inquiry, setInquiry] = useState<Inquiry | null>(null);
  const [isFetchingInquiry, setIsFetchingInquiry] = useState<boolean>(true);
  const [locationId, setLocationId] = useState<string | null>(null);
  const [isFinished, setIsFinished] = useState<boolean>(false);
  const { inquiryId } = useParams<{ inquiryId: string }>();

  const GOOGLE_OAUTH_INQUIRY_REDIRECT = process.env
    .REACT_APP_GOOGLE_OAUTH_INQUIRY_REDIRECT as string;

  useEffect(() => {
    const loadInquiry = async () => {
      setIsFetchingInquiry(true);
      if (!inquiryId) return;

      try {
        const res = await heroApiService.getInquiryById(inquiryId);
        if (res) {
          setInquiry(res);
          setIsFinished(res.status === 3);
          setLocationId(res.location_id);
        }
      } catch (error) {
        console.log(error);
      }
      setIsFetchingInquiry(false);
    };
    loadInquiry();
  }, [inquiryId]);

  useEffect(() => {
    const initLocation = async () => {
      if (locationId) {
        const res = await heroApiService.getLocationById(locationId);
        setLocation(res);
      }
    };
    initLocation();
  }, [locationId]);

  useEffect(() => {
    if (locationId && inquiryId) {
      dispatch(
        openInquiryEmail({
          inquiryId,
        })
      );
    }
  }, [locationId, inquiryId]);

  return (
    <div
      style={{
        background:
          "url('https://media.istockphoto.com/id/1010335754/photo/photo-blurred-of-coffee-shop-or-modern-library-abstract-bokeh-light.jpg?b=1&s=170667a&w=0&k=20&c=dtuA7ceXXGA8rQWB35shXNPcHPNyWON27plGOLHY6LQ=')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}>
      <div
        style={{
          backgroundColor: 'white',
          padding: '50px 30px',
          boxShadow:
            'box-shadow: box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;',
          height: 'fit-content',
          marginTop: 30,
          width: !breakpoint.isDesktop ? 900 : '100%',
          justifyContent: 'center',
          display: 'flex',
        }}>
        <Space direction="vertical" style={{ justifyContent: 'center' }}>
          <LoadableContainer isLoading={isFinished} loadComponent={<RenderFinishedContent />}>
            <LoadableContainer
              isLoading={isFetchingInquiry}
              loadComponent={
                <div style={{ textAlign: 'center', fontSize: 30 }}>
                  <LoadingOutlined />
                </div>
              }>
              {!inquiry ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}>
                  <MehOutlined style={{ fontSize: 50 }} />
                  <div style={{ marginTop: 30, width: '70%' }}>
                    <h1 style={{ textAlign: 'center' }}>Invalid Link</h1>
                    <p>The link you are looking for is invalid or has been expired.</p>
                  </div>
                </div>
              ) : (
                <React.Fragment>
                  {location && (
                    <React.Fragment>
                      <h2>Give us a chance to make this right for you</h2>
                      <p>
                        {location.owner_contact && location.owner_contact.given_name
                          ? `Hi! It's ${location.owner_contact.given_name}, the owner of ${location.title}`
                          : `Hi! I'm the owner of ${location.title}`}
                        <br />
                        <br />
                        Firstly, we sincerely appreciate the time you took to provide us with your
                        feedback. We truly value your opinion. I want to let you know that my team
                        and I are taking necessary steps to improve upon your feedback.
                        <br />
                        <br />
                        We would be grateful for a chance to make this right for you and appreciate
                        it if you could allow us to contact you via the form below. I would love to
                        send you an email and provide a solution.
                        <br />
                        <br />
                        Your opinion matters greatly to us, and we are committed to making your
                        future engagement with us truly exceptional. Thank you once again and I look
                        forward to making this right for you.
                        <br />
                        <br />
                        Best regards
                        {location.owner_contact ? (
                          <>
                            ,<br />
                            {location.owner_contact.given_name}.
                          </>
                        ) : (
                          '.'
                        )}
                      </p>
                      <div style={{ textAlign: 'center' }}>
                        <strong>Let us know your contact via email</strong>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Form
                          name="normal_login"
                          className="login-form"
                          initialValues={{ remember: true }}
                          onFinish={() => setIsFinished(true)}>
                          <Form.Item>
                            <Button
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '14px',
                              }}
                              htmlType="submit"
                              className="login-form-button"
                              shape="round"
                              icon={
                                <Icon
                                  component={() => (
                                    <img
                                      alt="google-icon"
                                      src="google.png"
                                      style={{
                                        width: 18,
                                        height: 18,
                                      }}
                                    />
                                  )}
                                />
                              }
                              href={getGoogleUrl(inquiryId, GOOGLE_OAUTH_INQUIRY_REDIRECT)}>
                              Continue with Google
                            </Button>
                          </Form.Item>
                        </Form>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </LoadableContainer>
          </LoadableContainer>
        </Space>
      </div>
    </div>
  );
};

export default InquiryCallbackScreen;
